import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  fetchKbDetail: ['kbNumber', 'userName', 'time_zone', 'lang'],
  fetchKbDetailSuccess: ['kbDetail'],
  getKbUsefulPercentage: ['params'],
  getKbUsefulPercentageSuccess: ['kbUsefulPercentage'],
  getUsefulByUser: ['params'],
  getUsefulByUserSuccess: ['kbUseful'],
  fetchRatings: ['params'],
  fetchRatingsSuccess: ['rating'],
  updateViewCount: ['userName', 'id'],
  updateUsefulChange: ['usefulChange', 'params', 'id'],
  updateUsefulChangeSuccess: ['usefulChange'],
  updateRatingChange: ['ratingChange', 'params', 'kbNumber', 'userName', 'timeZone'],
  updateRatingChangeSuccess: ['ratingChange'],
  fetchLatestComment: ['kb_uid'],
  fetchLatestCommentSuccess: ['lastComment'],
  fetchCommentsData: ['params'],
  fetchCommentsDataSuccess: ['commentsData'],
  provideCommentFeedback: ['params', 'currentPage'],
  reloadCommentsDataSuccess: [],
  provideLikeComment: ['username', 'like', 'comment'],
  provideCommentDeleted: ['commentId'],
  provideCommentEdited: ['commentId', 'paramsObj'],
  getMostViewedArticles: ['params'],
  getMostViewedArticlesSuccess: ['mostViewedArticles'],
  reset: [],
  setLoadingKB: ['isLoading'],
  fetchAllAttachment: ['kbNumber'],
  fetchAllAttachmentSuccess: ['allAttachment'],
  setLoadingFeedback: ['isLoadingFeedback'],
  setOpenFeedbackDialog: ['isOpenFeedbackDialog'],
  setLoadingComment: ['isLoadingComment'],
});
export const KnowledgeDetailTypes = Types;
export default Creators;
